import { css } from '@emotion/react';
import { Box, Divider, Group, desktopFirstMediaQuery, useTheme } from '@inflearn/ds-react';
import type { ReactNode } from 'react';

import useHandleDormantUser from '../../hooks/useHandleDormantUser';
import InstructorProfileNavigation from './UserProfileNavigation/index.instructor';
import StudentProfileNavigation from './UserProfileNavigation/index.student';

type Props = {
  children: ReactNode;
  isInstructor: boolean;
  isInactive: boolean;
  asideChildren?: ReactNode;
};

export default function Layout({ children, isInstructor, isInactive, asideChildren }: Props) {
  const theme = useTheme();

  useHandleDormantUser(isInactive);

  return (
    <Group maw={1200} m="0 auto" align="normal" css={stylesContainer}>
      <Box
        component="aside"
        pt={40}
        pr={32}
        css={[{ borderRight: `1px solid ${theme.colors.gray[2]}` }, stylesNavigation]}
      >
        <Box w={243}>
          {isInstructor ? <InstructorProfileNavigation /> : <StudentProfileNavigation />}
          {asideChildren}
        </Box>
      </Box>
      <Divider
        size={8}
        color="gray.0"
        css={{
          display: 'none',
          [desktopFirstMediaQuery.tablet]: { display: 'block' },
        }}
      />
      <Box css={stylesContent}>{children}</Box>
    </Group>
  );
}

const stylesContainer = css({
  minHeight: 800,
  padding: '0 32px',

  [desktopFirstMediaQuery.tablet]: {
    padding: 0,
    flexDirection: 'column',
  },
  [desktopFirstMediaQuery.mobile]: {
    padding: 0,
  },
});

const stylesNavigation = css({
  [desktopFirstMediaQuery.tablet]: {
    width: '100%',
    border: 'none',
    padding: '24px 32px 0',
    '& > div': {
      width: '100%',
    },
  },
  [desktopFirstMediaQuery.mobile]: {
    padding: '24px 16px 0',
  },
});

const stylesContent = css({
  flex: 1,
  width: '100%',
  height: '100%',
  minWidth: 0,
  padding: '20px 0 24px 32px',
  [desktopFirstMediaQuery.tablet]: {
    padding: 32,
  },
  [desktopFirstMediaQuery.mobile]: {
    padding: '0 16px 20px',
  },
});
